import 'hammerjs';
import 'picturefill';
import 'object-fit-images';
import smoothscroll from 'smoothscroll-polyfill';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { initPortalObservability, registerGlobalErrorHandlers } from './app/core/observability/observability';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

initPortalObservability(environment);
registerGlobalErrorHandlers(environment);

smoothscroll.polyfill();
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
